// AppRoutes.jsx
import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Header from "./components/H&F/Header.jsx";
import Footer from "./components/Landing/components/Footer.jsx";
import Forgot from "./components/Login/Forgot.jsx";
import Support from "./Pages/Support.jsx";
import Ticketdashboard from "./Pages/Ticketdashboard.jsx";
import Ticketrise from "./Pages/Ticketrise.jsx";
import Report from "./components/Menu/Report.jsx";
import Shift from "./components/Menu/Shift.jsx";
import Landing from "./components/Landing/components/Landing.jsx";
import Demo from "./Pages/demo.jsx";

// ProtectedRoute Component
const ProtectedRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem("userdetails"));

  localStorage.setItem("manualLogout", "true");

  const manualLogout = localStorage.getItem("manualLogout") === "true";
  if (!user) {
    if (!manualLogout) {
      alert("Session expired or not logged in. Redirecting to login.");
    }
    localStorage.removeItem("manualLogout");
    return <Navigate to="/" replace />;
  }

  return children;
};

const AppRoutes = () => {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("userdetails");
    setIsLoggedIn(!!user);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");

    if (status === "success") {
      alert("User signup successfully");
      window.history.replaceState(null, "", window.location.pathname);
    } else if (status === "exists") {
      alert("User already exists");
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);

  return (
    <div className="app">
      {location.pathname !== "/" && (
        <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
      )}

      <main className="main-content">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/Forgot" element={<Forgot />} />
          <Route path="/demo" element={<Demo />} />

          {/* Protected Routes */}
          <Route
            path="/CM"
            element={
              <ProtectedRoute>
                <Ticketdashboard />
              </ProtectedRoute>
            }
          />
          <Route               
            path="/CU"
            element={
              <ProtectedRoute>
                <Ticketrise />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SU"
            element={
              <ProtectedRoute>
                <Support />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Report />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shiftschedule"
            element={
              <ProtectedRoute>
                <Shift />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>

      {location.pathname !== "/" && <Footer />}
    </div>
  );
};

export default AppRoutes;
